import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { MODERNIZE_CONFLUENCE_IPM_MODAL } from '../../constants/onboarding-state/onboarding-constants.ts';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql.ts';

export const preloadModernizeConfluenceOnboardingState = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [...Object.values(MODERNIZE_CONFLUENCE_IPM_MODAL)],
		},
	});
};
